import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { teacherTypography } from './typography';
import { unifiedUI } from './unified';

/** Reusable teacher/admin metric surface (not modeled on Teacher Homepage). */
export function UnifiedMetricCard({ label, value, help, emphasis = false, compact = false,
  density = 'default', valueKind = 'number', icon: Icon, unit }) {
  const report = density === 'report';
  return <Paper elevation={0} data-teacher-metric={report ? label : undefined} sx={{
    ...unifiedUI.surfaceCard,
    p: report ? 1.5 : compact ? { xs: 1.25, sm: 1.75, md: 2.25 } : { xs: 1.75, md: 2.25 },
    minWidth: 0, height: '100%',
    bgcolor: emphasis ? unifiedUI.purpleSurface : unifiedUI.surface,
    borderColor: emphasis ? '#DDD2FF' : unifiedUI.border,
  }}>
    <Stack spacing={0.4}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: report ? 0.35 : 0 }}>
        {Icon && <Icon aria-hidden="true" sx={{ fontSize: 16, color: unifiedUI.purple, display: { xs: 'none', sm: 'block' } }} />}
        <Typography sx={{ ...teacherTypography.metricLabel, fontSize: report ? 12 : 13 }}>{label}</Typography>
      </Box>
      <Typography data-testid="unified-metric-value" data-teacher-metric-value sx={{
        ...teacherTypography.kpiValue, color: unifiedUI.ink,
        fontSize: valueKind === 'text' ? 17 : report ? 26 : { xs: 27, md: 32 },
        ...(report ? { lineHeight: '34px', color: emphasis ? unifiedUI.purple : unifiedUI.ink } : {}),
        fontVariantNumeric: 'tabular-nums', overflowWrap: 'anywhere',
      }}>{value}{unit && <Typography component="span" sx={{ fontSize: 12, ml: 0.5, whiteSpace: 'nowrap', color: unifiedUI.secondary }}>{unit}</Typography>}</Typography>
      {help && <Typography sx={{ ...teacherTypography.supportingText, fontSize: report ? 12 : 13, color: unifiedUI.secondary }}>{help}</Typography>}
    </Stack>
  </Paper>;
}

/** Shared semantic heading/description/action pattern for list and report sections. */
export function UnifiedSectionHeader({ title, description, action, level = 'h2' }) {
  return <Box sx={{
    display: 'flex', alignItems: { xs: 'stretch', md: 'center' },
    flexDirection: { xs: 'column', md: 'row' }, gap: 1.5,
    justifyContent: 'space-between', minWidth: 0,
  }}>
    <Box sx={{ minWidth: 0 }}>
      <Typography component={level} sx={{ ...teacherTypography.sectionTitle, lineHeight: 1.4, overflowWrap: 'anywhere' }}>{title}</Typography>
      {description ? <Typography sx={{ ...teacherTypography.supportingText, fontSize: 14, mt: 0.4 }}>{description}</Typography> : null}
    </Box>
    {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
  </Box>;
}
